import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../config/analytics/analytics.config";
import { AuthProvider } from "../config/authentication/auth-context";
import "../config/i18next/i18next";
import "../config/notifications/notifications.config";
import "./app.scss";
import Auth from "./entities/auth";
import Candidate from "./entities/candidate";
import Homepage from "./entities/homepage";
import Footer from "./shared/components/footer/footer";
import Header from "./shared/components/header/header";
import ToggleSubscriptionProvider, { OnlyIfOpenSubscriptionLayout } from "./shared/components/toggle-subscription-context/toggle-subscription-context";

const App = () => (
    <React.StrictMode>
        <BrowserRouter>
            <ToggleSubscriptionProvider>
                <Header />
                <Routes>
                    <Route path="/" element={<Homepage.Home />} />
                    <Route path="/group" element={<Homepage.Group />} />
                    <Route path="/faq" element={<Homepage.Faq />} />
                    <Route path="/login" element={<Auth.Login />} />
                    <Route path="/join" element={<OnlyIfOpenSubscriptionLayout />}>
                        <Route index element={<Candidate.Join />}/>
                        <Route path="success" element={<Candidate.JoinSuccess />}/>
                    </Route>
                    <Route
                        path="/logout"
                        element={
                            <AuthProvider>
                                <Auth.Logout />
                            </AuthProvider>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <AuthProvider>
                                <Auth.Admin />
                            </AuthProvider>
                        }
                    />
                    <Route
                        path="/admin/candidates"
                        element={
                            <AuthProvider>
                                <Candidate.ListCandidates />
                            </AuthProvider>
                        }
                    />
                </Routes>
                <Footer />
            </ToggleSubscriptionProvider>
        </BrowserRouter>
    </React.StrictMode>
);

export default App;
